import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89ccd62c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-toast-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_toast_icon = _resolveComponent("oxd-toast-icon")!
  const _component_oxd_text = _resolveComponent("oxd-text")!
  const _component_oxd_toast_close_button = _resolveComponent("oxd-toast-close-button")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.classes),
        "aria-live": "assertive",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickToast && _ctx.onClickToast(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "icon", {}, () => [
            _createVNode(_component_oxd_toast_icon, { type: _ctx.type }, null, 8, ["type"])
          ], true),
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.contentClasses)
            }, [
              _createVNode(_component_oxd_text, {
                type: "toast-title",
                class: "oxd-toast-content-text"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.title), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_oxd_text, {
                type: "toast-message",
                class: "oxd-toast-content-text"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.message), 1)
                ]),
                _: 1
              })
            ], 2)
          ], true)
        ]),
        _renderSlot(_ctx.$slots, "close", {}, () => [
          _createVNode(_component_oxd_toast_close_button, {
            type: _ctx.type,
            onClick: _ctx.onClickClose
          }, null, 8, ["type", "onClick"])
        ], true)
      ], 2))
    : _createCommentVNode("", true)
}